import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVendor } from "src/models/Products/Vendor.models";

interface vendorstate {
  vendors: IVendor[];
  vendorToEdit: IVendor | null;
}

const initialState: vendorstate = {
  vendors: [],
  vendorToEdit: null,
};

const vendorSlice = createSlice({
  name: "Vendor",
  initialState,
  reducers: {
    setVendorList: (state, action: PayloadAction<IVendor[]>) => {
      state.vendors = action.payload;
    },
    concatListVendor: (
      state: vendorstate,
      action: PayloadAction<IVendor[]>
    ) => {
      state.vendors = [...state.vendors.concat(action.payload)];
    },
    setVendorToEdit: (state, action: PayloadAction<IVendor | null>) => {
      state.vendorToEdit = action.payload;
    },
    addVendor: (state, action: PayloadAction<IVendor>) => {
      state.vendors.push(action.payload);
    },
    addVendors: (state, action: PayloadAction<IVendor[]>) => {
      state.vendors.push(...action.payload);
    },
    updateVendor: (state, action: PayloadAction<IVendor>) => {
      let itemIndex = state.vendors.findIndex(
        item => item.vendorId === action.payload.vendorId
      );
      if (itemIndex !== -1) state.vendors[itemIndex] = action.payload;
    },
    deleteVendor: (state, action: PayloadAction<number>) => {
      const newArray = state.vendors.filter(
        item => item.vendorId !== action.payload
      );
      state.vendors = newArray;
    },
  },
});

export const {
  setVendorList,
  concatListVendor,
  setVendorToEdit,
  addVendor,
  addVendors,
  updateVendor,
  deleteVendor,
} = vendorSlice.actions;

export default vendorSlice.reducer;
